module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "level1 hidden",
    attrs: {
      "data-number": "2",
      "epub:type": "epigraph",
      "id": "epigraph"
    }
  }, [_c('h1', {
    staticClass: "hidden",
    attrs: {
      "data-number": "2",
      "epub:type": "epigraph"
    }
  }, [_vm._v("Epigraph")]), _vm._v(" "), _c('blockquote', [_c('p', [_c('em', [_vm._v("Panic stricken by the unexpectedness of the invaders’ expedition, by their numbers, by the huge size of their bodies and by the strange and terrifying sound of their voices, they forgot their training in military science and hence lost the use of their valour.")])])]), _vm._v(" "), _c('p', {
    staticClass: "right_align_para"
  }, [_vm._v("Cassius Dio – "), _c('em', [_vm._v("Roman History")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0243bd62","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch002.vue
// module id = 66
// module chunks = 0